(() => {
  const feeds = document.querySelectorAll('[data-pokespott-judgeme-feed]');
  if (!feeds.length) return;

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const formatDate = (iso) => {
    if (!iso) return '';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const initials = (name) => {
    const parts = String(name || 'C').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return 'C';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const renderStars = (rating) => {
    const n = Math.max(0, Math.min(5, Number(rating) || 0));
    return '★'.repeat(n) + '☆'.repeat(5 - n);
  };

  const resolveUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('//')) return `${window.location.protocol}${url}`;
    return url;
  };

  const isShowcaseLayout = (root) =>
    Boolean(root.closest('.pokespott-reviews__body--showcase, .pokespott-reviews__body--spotlight'));

  const renderReview = (review, layout, showcase) => {
    const item = document.createElement('article');
    item.className = 'pokespott-judgeme-feed__item';
    if (layout === 'carousel') item.classList.add('pokespott-judgeme-feed__item--slide');
    item.setAttribute('role', 'listitem');

    const displayName = review.name || 'Collectionneur';
    const body = review.body || '';
    const date = formatDate(review.created_at);
    const title = review.title || '';
    const bodyText = showcase && body.length > 220 ? `${body.slice(0, 217).trim()}…` : body;

    if (showcase) {
      item.innerHTML = `
        <div class="pokespott-judgeme-feed__item-inner pokespott-judgeme-feed__item-inner--showcase">
          <header class="pokespott-judgeme-feed__item-top">
            <div class="pokespott-judgeme-feed__avatar" aria-hidden="true">${escapeHtml(initials(displayName))}</div>
            <div class="pokespott-judgeme-feed__item-identity">
              <p class="pokespott-judgeme-feed__item-author">${escapeHtml(displayName)}</p>
            </div>
          </header>
          <div class="pokespott-judgeme-feed__item-stars" aria-label="Note ${review.rating} sur 5">${renderStars(review.rating)}</div>
          ${title ? `<h3 class="pokespott-judgeme-feed__item-title">${escapeHtml(title)}</h3>` : ''}
          <p class="pokespott-judgeme-feed__item-body">${escapeHtml(bodyText)}</p>
          ${date ? `<time class="pokespott-judgeme-feed__item-date" datetime="${escapeHtml(review.created_at || '')}">${escapeHtml(date)}</time>` : ''}
        </div>
      `;
      return item;
    }

    const meta = [];
    if (review.verified) meta.push('Achat vérifié');
    if (date) meta.push(date);
    const legacyBody = layout === 'carousel' && body.length > 180 ? `${body.slice(0, 177).trim()}…` : body;

    item.innerHTML = `
      <div class="pokespott-judgeme-feed__item-inner">
        <div class="pokespott-judgeme-feed__avatar" aria-hidden="true">${escapeHtml(initials(displayName))}</div>
        <div class="pokespott-judgeme-feed__item-content">
          <header class="pokespott-judgeme-feed__item-head">
            <p class="pokespott-judgeme-feed__item-author">${escapeHtml(displayName)}</p>
            <div class="pokespott-judgeme-feed__item-stars" aria-label="Note ${review.rating} sur 5">${renderStars(review.rating)}</div>
          </header>
          ${review.title ? `<h3 class="pokespott-judgeme-feed__item-title">${escapeHtml(review.title)}</h3>` : ''}
          <p class="pokespott-judgeme-feed__item-body">${escapeHtml(legacyBody)}</p>
          ${meta.length ? `<p class="pokespott-judgeme-feed__item-meta">${meta.map(escapeHtml).join(' · ')}</p>` : ''}
        </div>
      </div>
    `;

    return item;
  };

  const setupShowcaseAutoscroll = (root, list, reviews) => {
    if (!list || reviews.length < 1) return;

    root.classList.add('pokespott-judgeme-feed--autoscroll');

    if (reviews.length < 2) return;

    const items = [...list.children];
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('pokespott-judgeme-feed__item--clone');
      list.appendChild(clone);
    });

    const duration = Math.max(28, items.length * 8);
    root.style.setProperty('--pokespott-reviews-marquee-duration', `${duration}s`);
  };

  const setupCarouselNav = (root, track) => {
    const prev = root.querySelector('[data-pokespott-judgeme-prev]');
    const next = root.querySelector('[data-pokespott-judgeme-next]');
    if (!track || !prev || !next) return;

    if (isShowcaseLayout(root)) {
      prev.hidden = true;
      next.hidden = true;
      return;
    }

    const isMobileCarousel = () => window.matchMedia('(max-width: 749px)').matches;
    const scrollStep = () => Math.max(track.clientWidth * 0.85, 240);

    const updateNav = () => {
      if (isMobileCarousel()) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= maxScroll;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
    if (!isMobileCarousel()) {
      prev.hidden = false;
      next.hidden = false;
      updateNav();
    }
  };

  const renderSocialAvatars = (section, reviews) => {
    const container = section?.querySelector('[data-pokespott-reviews-avatars]');
    if (!container) return;

    const unique = [];
    reviews.forEach((review) => {
      const label = initials(review.name);
      if (!unique.some((entry) => entry.label === label)) {
        unique.push({ label, name: review.name || 'Collectionneur' });
      }
    });

    container.innerHTML = unique
      .slice(0, 4)
      .map(
        (entry) =>
          `<span class="pokespott-reviews__social-avatar" title="${escapeHtml(entry.name)}">${escapeHtml(entry.label)}</span>`
      )
      .join('');
  };

  const initFeed = (root) => {
    const layout = root.dataset.layout || 'list';
    const loading = root.querySelector('[data-pokespott-judgeme-loading]');
    const list = root.querySelector('[data-pokespott-judgeme-list]');
    const empty = root.querySelector('[data-pokespott-judgeme-empty]');
    const summary = root.querySelector('[data-pokespott-judgeme-summary]');
    const averageEl = root.querySelector('[data-pokespott-judgeme-average]');
    const countEl = root.querySelector('[data-pokespott-judgeme-count]');
    const track = root.querySelector('[data-pokespott-judgeme-track]');
    const reviewsBody = root.closest('.pokespott-reviews__body');
    const section = root.closest('.pokespott-reviews');
    const showcase = isShowcaseLayout(root);

    const scoreCard = section?.querySelector('[data-pokespott-reviews-score]');
    const scoreValue = section?.querySelector('[data-pokespott-reviews-score-value]');
    const scoreCount = section?.querySelector('[data-pokespott-reviews-score-count]');
    const scoreBreakdown = section?.querySelector('[data-pokespott-reviews-breakdown]');
    const footer = section?.querySelector('[data-pokespott-reviews-footer]');

    const finishLoading = () => {
      if (loading) loading.hidden = true;
    };

    const updateReviewCta = () => {
      const cta = section?.querySelector('[data-pokespott-reviews-cta]');
      const label = cta?.querySelector('.pokespott-reviews__cta-label');
      if (!label) return;
      label.textContent = cta.dataset.labelHas || 'Laisser un avis';
    };

    const showReviews = (reviews, avg) => {
      root.hidden = false;
      if (reviewsBody) reviewsBody.classList.add('pokespott-reviews__body--has-reviews');
      if (footer) footer.hidden = false;

      const avgText = Number(avg).toFixed(1).replace('.', ',');
      const countText = reviews.length === 1 ? '1 avis vérifié' : `${reviews.length} avis vérifiés`;
      const countTextShort = reviews.length === 1 ? '1 avis publié' : `${reviews.length} avis publiés`;

      if (summary && averageEl && countEl) {
        averageEl.textContent = `${avgText} / 5`;
        countEl.textContent = countTextShort;
        summary.hidden = false;
      }

      if (scoreCard && scoreValue && scoreCount) {
        scoreValue.textContent = `${avgText} / 5`;
        scoreCount.textContent = `Basé sur ${countText}`;
        scoreCard.hidden = false;
      }

      if (scoreBreakdown) {
        const total = reviews.length;
        const buckets = [0, 0, 0, 0, 0];
        reviews.forEach((r) => {
          const n = Math.max(1, Math.min(5, Math.round(Number(r.rating) || 0)));
          buckets[n - 1] += 1;
        });
        const rows = [5, 4, 3, 2, 1].map((star) => {
          const count = buckets[star - 1];
          const pct = total ? Math.round((count / total) * 100) : 0;
          return `
            <div class="pokespott-reviews__dist-row">
              <span class="pokespott-reviews__dist-label">${star}<span class="pokespott-reviews__dist-star" aria-hidden="true">★</span></span>
              <span class="pokespott-reviews__dist-bar"><span class="pokespott-reviews__dist-fill" style="width:${pct}%"></span></span>
              <span class="pokespott-reviews__dist-value">${pct}% (${count})</span>
            </div>`;
        });
        scoreBreakdown.innerHTML = rows.join('');
        scoreBreakdown.hidden = false;
      }

      renderSocialAvatars(section, reviews);
      updateReviewCta();

      if (showcase) root.classList.add('pokespott-judgeme-feed--showcase');

      // Toujours passer layout réel (carousel) pour la classe --slide.
      // cardLayout='showcase' cassait le max-width → texte sur une seule ligne qui élargit la carte.
      reviews.forEach((review) => list.appendChild(renderReview(review, layout, showcase)));

      if (layout === 'carousel' && track) {
        if (showcase) {
          setupShowcaseAutoscroll(root, list, reviews);
        } else {
          setupCarouselNav(root, track);
        }
      }
    };

    const showEmptyFallback = () => {
      if (reviewsBody) reviewsBody.classList.add('pokespott-reviews__body--no-reviews');
    };

    const reviewsUrl = resolveUrl(root.dataset.reviewsUrl);
    if (!reviewsUrl) {
      finishLoading();
      if (empty) empty.hidden = false;
      showEmptyFallback();
      return;
    }

    fetch(`${reviewsUrl}${reviewsUrl.includes('?') ? '&' : '?'}_=${Date.now()}`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('fetch failed'))))
      .then((data) => {
        finishLoading();
        const reviews = Array.isArray(data.reviews) ? data.reviews : [];
        if (!reviews.length) {
          showEmptyFallback();
          return;
        }

        const avg = data.average_rating || reviews.reduce((s, r) => s + (r.rating || 0), 0) / reviews.length;
        showReviews(reviews, avg);
      })
      .catch(() => {
        finishLoading();
      });
  };

  feeds.forEach(initFeed);
})();
